import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHorizontalAlignmentCenter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"horizontal-alignment-center"} maskId="square-filled-radius-0-stroke-1-IconHorizontalAlignmentCenter"><path d="M6 4V11.5H3V12.5H6V20H11V12.5H13V18H18V12.5H21V11.5H18V6H13V11.5H11V4H6Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconHorizontalAlignmentCenter;
